/**
 * Store: Index
 * -----------------------------------------------------------------------------
 * Root store for all theme level states.
 * - Tied to the index component.
 * - Only JSDOC custom parameters, ignore module state or object.
 *
 */
export default {
  state: () => ({
    hydrated: false,
    previousUrl: '/',
    screen: {
      breakpoint: 'xs',
      height: 0,
      mobile: true,
      width: 0,
    },
    settings: {
      start: 100,
      threshold: 5,
      throttle: 250,
    },
    scroll: {
      direction: 'none',
      header: 'open',
      top: true,
      x: 0,
      y: 0,
    },
    stylesheets: [],
  }),

  mutations: {

    /**
     * Set rehydrated state.
     */
    SET_HYDRATED(state) {
      state.hydrated = true
    },

    /**
     * Set previous URL state.
     * @param {String} pathname - Previous pathname.
     */
    SET_PREVIOUS_URL(state, pathname) {
      state.previousUrl = pathname
    },

    /**
     * Set screen state.
     * @param {Object} screen - Screen state object.
     */
    SET_SCREEN(state, screen) {
      state.screen = screen
    },

    /**
     * Set scroll state.
     * @param {Object} scroll - Scroll state object.
     */
    SET_SCROLL(state, scroll) {
      state.scroll = scroll
    },

    /**
     * Set loaded stylesheets.
     * @param {String} stylesheet - Loaded stylesheet file name.
     */
    SET_STYLESHEET(state, stylesheet) {
      state.stylesheets.push(stylesheet)
    },
  },

  actions: {

    /**
     * Commit rehydrated state.
     * - Runs initial items.
     */
    async rehydrateSite({ dispatch, commit }) {
      commit('SET_HYDRATED')

      await Promise.all([dispatch('cart/setResponse', true)])
    },

    /**
     * Commit previous URL state.
     * @param {String} pathname - Previous pathname.
     */
    setPreviousUrl({ commit }, pathname) {
      commit('SET_PREVIOUS_URL', pathname)
    },

    /**
     * Commit screen state.
     * @param {Object} screen - Screen state object.
     */
    setScreen({ commit }, screen) {
      commit('SET_SCREEN', screen)
    },

    /**
     * Commit scroll state.
     * @param {Object} scroll - Scroll state object.
     */
    setScroll({ commit }, scroll) {
      commit('SET_SCROLL', scroll)
    },

    /**
     * Commit loaded stylesheet state.
     * @param {String} stylesheet - Loaded stylesheet file name.
     */
    setStylesheet({ commit }, stylesheet) {
      commit('SET_STYLESHEET', stylesheet)
    },
  },
}
